"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var TextController = /** @class */ (function (_super) {
    __extends(TextController, _super);
    function TextController($scope, book) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.placeholder = $scope.option.placeholder;
        _this.pattern = $scope.option.pattern;
        _this.restrict = $scope.option.restrict;
        if ($scope.option.restrict) {
            _this.regexp = new RegExp('^' + $scope.option.restrict + '$');
        }
        $scope.$watch(function () { return book; }, function () {
            if (_this.form.value !== _this.book.get(_this.prefix, _this.id)) {
                _this.form.value = _this.book.get(_this.prefix, _this.id);
            }
        }, true);
        _this.form.value = _this.book.get(_this.prefix, _this.id);
        _this.onChange();
        return _this;
    }
    TextController.prototype.onChange = function () {
        if (typeof this.form.value === 'undefined' || this.regexp && !this.regexp.test(this.form.value)) {
            this.form.value = this.book.get(this.prefix, this.id);
        }
        else {
            this.book.set(this.prefix, this.id, this.form.value);
        }
    };
    return TextController;
}(form_1.FormOptionController));
exports.TextController = TextController;
function TextDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/text.html',
        controller: TextController,
        controllerAs: 'textCtrl'
    };
}
exports.TextDirective = TextDirective;
